module.exports = __webpack_public_path__ + "img/avartar_empty.f4b287e2.png";